import { Environment } from './environment.model';
import instanceParam from '../../public/instance.json';

export const ENV: Environment = {
  mode: 'Development',
  version: instanceParam.VERSION || '0.0.0.1',
  production: false,
  api_baseurl: instanceParam.API_BASEURL,
  orthanc_baseurl: instanceParam.ORTHANC_BASEURL || '',
};
